import type { EnglishLevel } from "./types";

export const LEVEL_LABELS: Record<EnglishLevel, string> = {
  beginner: "初级",
  intermediate: "中级",
  advanced: "高级",
};

const LEVEL_ORDER: EnglishLevel[] = ["beginner", "intermediate", "advanced"];

export function levelToScore(level: EnglishLevel): number {
  return LEVEL_ORDER.indexOf(level);
}

export function scoreToLevel(score: number): EnglishLevel {
  const clamped = Math.max(0, Math.min(2, Math.round(score)));
  return LEVEL_ORDER[clamped];
}

export function nudgeLevelDown(level: EnglishLevel): EnglishLevel {
  const idx = LEVEL_ORDER.indexOf(level);
  return idx > 0 ? LEVEL_ORDER[idx - 1]! : level;
}

export function nudgeLevelUp(level: EnglishLevel): EnglishLevel {
  const idx = LEVEL_ORDER.indexOf(level);
  return idx < LEVEL_ORDER.length - 1 ? LEVEL_ORDER[idx + 1]! : level;
}

export function parseEnglishLevel(value: unknown, fallback: EnglishLevel = "intermediate"): EnglishLevel {
  const s = String(value ?? "").trim();
  return LEVEL_ORDER.includes(s as EnglishLevel) ? (s as EnglishLevel) : fallback;
}
